module.exports = __webpack_public_path__ + "static/media/qustionactive.2eae5883.png";